var _objectSpread = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _defineProperty = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var path = require('path');

var fs = require('fs');
/*************** This is the store implementation for local file system storage ****************/


var Store =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @param storeInitOpt
   * @param storeInitOpt.storeName {string} store name
   * @param storeInitOpt.storeLocation {string} store path
   * @param storeInitOpt.defaultData {Object} any init data in JSON format
   */
  function Store(storeInitOpt) {
    _classCallCheck(this, Store);

    var _ref = storeInitOpt || {},
        _ref$storeLocation = _ref.storeLocation,
        storeLocation = _ref$storeLocation === void 0 ? './' : _ref$storeLocation,
        storeName = _ref.storeName,
        _ref$defaultData = _ref.defaultData,
        defaultData = _ref$defaultData === void 0 ? {} : _ref$defaultData;

    try {
      this.path = path.join(storeLocation, storeName);
    } catch (err) {
      throw Error("Unable to verify store path: " + "".concat(storeLocation).concat(storeName) + ". please provide valid storeLocation with storeName");
    }

    this.storeName = storeName;
    var isFileExist;

    try {
      isFileExist = fs.existsSync(this.path);
    } catch (err) {
      throw Error("Unable to check if local file system store already exists");
    }

    if (isFileExist) {
      var dataJson;

      try {
        dataJson = JSON.parse(fs.readFileSync(this.path, 'utf8'));
      } catch (err) {
        throw Error("File exists, but unable to load the store data from local file system : " + err);
      }

      this.data = dataJson;
    } else {
      try {
        fs.writeFileSync(this.path, JSON.stringify(defaultData, null, 2));
      } catch (err) {
        throw Error("Unable to create local file system store under " + this.path);
      }

      this.data = defaultData;
    }
  }

  _createClass(Store, [{
    key: "set",
    value: function set(key, value) {
      // use updateStore in util to access this function, since empty value check is moved to there to avoid circular require
      var jsonData = _defineProperty({}, key, value);

      var newData = _objectSpread({}, this.data, jsonData);

      fs.writeFileSync(this.path, JSON.stringify(newData, null, 2), function (err) {
        if (err) throw Error("Unable to write to local file system when set data to store: " + err);
      });
      this.data = newData;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.data[key];
    }
  }]);

  return Store;
}();

module.exports = Store;